export default "__VITE_ASSET__CGG2dScA__"